import React from 'react';
import {observer} from 'mobx-react';
import ReviewList from './ReviewList';
import {WriteReviewState} from '../state';
import {withState, t} from 'shared/core';
import {ReviewDetails} from '../../review_details';
import RevieweeDetails from './RevieweeDetails';
import {Spinner, Layout} from 'components';

const WriteReviewsContainerWithLoader = observer(({uiState, cycle, match}) => {
  const {currentReview, isLoadingReview, visibilityNotice, errors} = uiState;
  if (isLoadingReview) return <Spinner/>;

  const {employee} = currentReview.reviewee;

  return (
    <Layout>
      <Layout.Section secondary>
        <ReviewList uiState={uiState} />
      </Layout.Section>
      <Layout.Section>
        {isLoadingReview && <Spinner />}
        {!isLoadingReview &&
          <div className='is-fading-in fs-hide'><RevieweeDetails employee={employee}/>
            <ReviewDetails title={t('performance_reviews.view.My Feedback')}
              uiState={uiState}
              description={t(visibilityNotice, {
                employee: employee.firstName
              })}
              errors={errors}
              review={currentReview}
              isOpen={uiState.submitReviewModalOpen}
              onOpen={() => uiState.openSubmitReviewModal()}
              onHide={() => uiState.closeSubmitReviewModal()}
              onSubmit={() => uiState.submitReview()}
              onUnsubmit={() => uiState.unsubmitReview()}/>
          </div>
        }
      </Layout.Section>
    </Layout>
  );
});

export default withState(WriteReviewsContainerWithLoader, WriteReviewState);
